module.exports = __webpack_public_path__ + "img/coupon-overdue-icon.665fc35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/public/coupon-overdue-icon.png
// module id = /A5L
// module chunks = 1